import React from 'react';

import { Drawer, Button } from 'antd';

import AutoOrderForm from '../../../containers/ProfileCard/OLD-REPA/auto_order';

class DriverOrders extends React.PureComponent {
  render() {
    const { handleCloseAutoOrder, visible } = this.props;

    return (
      <Drawer
        title={
          <div>
            <h2>Загрузка водителя</h2>Александровский Александр Александрович
          </div>
        }
        width={896}
        placement={'left'}
        closable={false}
        onClose={handleCloseAutoOrder}
        visible={visible}
        className="auto-order"
      >
        <Button
          className="exclude_ts__hide"
          onClick={handleCloseAutoOrder}
          type="primary"
          shape="circle"
          icon="close"
          size={'small'}
        />
        <AutoOrderForm handle_close_auto_order={handleCloseAutoOrder} />
      </Drawer>
    );
  }
}

export default DriverOrders;
